import {Trans} from '@lingui/macro';
import React, {FC} from 'react';
import styled from 'styled-components';

import {Button} from '../../../../../../shared/ui/src/components/buttons/button';
import {ButtonVariantsEnum} from '../../../../../../shared/ui/src/components/buttons/buttonConstants';
import {Icon} from '../../../../../../shared/ui/src/components/icon/icon';

/*
 * Style.
 */

const StyledButtonContentDiv = styled.div`
  display: flex;
  align-items: center;
`;

const StyledButtonIcon = styled(Icon)`
  margin-right: 8px;
`;

/*
 * Component.
 */

export const ExportContactsButton: FC = () => (
  <Button variant={ButtonVariantsEnum.SECONDARY}>
    <StyledButtonContentDiv>
      <StyledButtonIcon name="exportSmall" size={16} />
      <Trans id="contacts-manager-export-button">Export</Trans>
    </StyledButtonContentDiv>
  </Button>
);
